var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConcreteAboutToExpire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6192 0.518555L19.7836 4.68292L18.5308 9.35898C17.245 7.4919 15.0914 6.26736 12.6513 6.26736C11.0685 6.26736 9.60706 6.78408 8.42548 7.65778L9.9298 2.04283L15.6192 0.518555ZM6.86573 9.23979L1.54674 10.6648L0.0224609 16.3542L4.18682 20.5186L8.68731 19.3129C6.78371 18.0333 5.53193 15.8584 5.53193 13.393C5.53193 11.8439 6.02614 10.4095 6.86573 9.23979ZM6.85573 7.6268L3.12127 8.62744L0.387004 5.89336L1.3879 2.15844L5.12236 1.15779L7.85663 3.89188L6.85573 7.6268Z",
    fill: "#002951"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6515 7.15796C9.20986 7.15796 6.42285 9.9512 6.42285 13.3929C6.42285 16.8346 9.20986 19.6278 12.6515 19.6278C16.0995 19.6278 18.8927 16.8346 18.8927 13.3929C18.8927 9.9512 16.0995 7.15796 12.6515 7.15796ZM12.6578 18.3808C9.90194 18.3808 7.66984 16.1487 7.66984 13.3929C7.66984 10.637 9.90194 8.40494 12.6578 8.40494C15.4136 8.40494 17.6457 10.637 17.6457 13.3929C17.6457 16.1487 15.4136 18.3808 12.6578 18.3808Z",
    fill: "#002951"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9434 9.89453H13.3418L13.3418 13.4336L15.812 15.9038L14.8231 16.8926L11.9438 14.0133L11.9438 14.0132H11.9434V9.89453Z",
    fill: "#002951"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcreteAboutToExpire);
export default __webpack_public_path__ + "static/media/concrete-about-to-expire.1cecf07eab7c2a5467ffb022b11eb66b.svg";
export { ForwardRef as ReactComponent };